import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavBudgetsInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || text_colorTextSecondary}
      fillRule="evenodd"
      d="M10.275 3.08v6.962l5.086 2.937.592.33.358.199A7.433 7.433 0 0 0 10.275 3.08Zm5.546 11.897.329.19a.849.849 0 0 0 1.165-.32 8.934 8.934 0 0 0-7.68-13.305.849.849 0 0 0-.86.85v.275a7.911 7.911 0 0 0 .676 15.792c2.292 0 3.998-1.052 5.11-2.07a9.474 9.474 0 0 0 1.25-1.398l.01-.014Zm-2.273.306c.412-.377.734-.755.965-1.06l-5.375-2.99a.85.85 0 0 1-.437-.743V4.182a6.411 6.411 0 0 0 .75 12.777c1.8 0 3.162-.82 4.097-1.676Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavBudgetsInactive
